import axios from 'axios';

console.log('INIT BASE URL:', process.env.REACT_APP_API_SERVER); // ✅ log untuk pastikan benar

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER, // ✅ WAJIB pakai prefix ini
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export default instance;